import moment from 'moment'

const filterQueryBuilder = filters => {
  // keyword            by_keyword=seo,ppc
  // tags                by_tag=seo,ppc
  // search engines      by_search_engine=google,bing
  // locations           by_location=UK,US
  // position            by_position[min]=1&by_position[max]=10&by_position[checkbox]=improved,declined,no_change
  // volume              by_volume[min]=1&by_volume[max]=10
  // traffic             by_traffic[min]=1&by_traffic[max]=10
  // KD                  by_keyword_difficlty[min]=1&by_keyword_difficlty[max]=10
  // SERP Features       by_serp_features=featured_snippet,all,you_rank,do_not_rank

  const keyToQuery = {
    startDate: 'by_date[from]',
    endDate: 'by_date[to]',
    keyword: 'by_keyword',
    positionsMin: 'by_position[min]',
    positionsMax: 'by_position[max]',
    volumeMinChange: 'by_volume[min]',
    volumeMaxChange: 'by_volume[max]',
    trafficMinChange: 'by_traffic[min]',
    trafficMaxChange: 'by_traffic[max]',
    kdMinChange: 'by_keyword_difficlty[min]',
    kdMaxChange: 'by_keyword_difficlty[max]',
    positionsChecklist: 'by_position[checkbox]',
    tagsChecklist: 'by_tag',
    enginesChecklist: 'by_search_engine',
    locationsChecklist: 'by_location',
    trackedFeaturesChecklist: 'by_serp_features',
    trackedFeatures: '',
    device: 'by_device',
    tags: 'by_tag',
    byAll: 'by_all',
    byNew: 'by_new',
    byLost: 'by_lost',
    byUp: 'by_up',
    byDown: 'by_down',
    email: 'by_email',
    page: 'page',
    perPage: 'per_page'
  }

  let querys = []

  if (!filters || Object.keys(filters).length === 0) {
    return ''
  }

  Object.keys(filters).forEach(key => {
    const isArray = Array.isArray(filters[key])
    const hasLength = isArray && filters[key].length > 0 ? true : false

    if (filters[key] && isArray === hasLength) {
      let value = null

      switch (key) {
        case 'trackedFeatures':
          // Just remove if `all`
          if (filters[key] !== 'all') {
            querys.push(`by_serp_feature_${filters[key]}`)
          }
          break
        case 'startDate':
        case 'endDate':
          value = moment(filters[key]).format('YYYY-MM-DD')
          querys.push(`${keyToQuery[key]}=${value}`)
          break
        default:
          value = filters[key]
          querys.push(`${keyToQuery[key]}=${value}`)
          break
      }
    }
  })

  return `?${querys.join('&')}`
}

export default filterQueryBuilder
